import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { HtmlContent } from '../components/RichTextEditor';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function DynamicPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(false);
    fetch(`${BACKEND_URL}/api/pages/${slug}`)
      .then(r => {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(data => { setPage(data); setLoading(false); })
      .catch(() => { setError(true); setLoading(false); });
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-amber-50">
        <div className="text-amber-700 text-lg animate-pulse">Yükleniyor...</div>
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-amber-50 gap-4">
        <h2 className="text-2xl text-amber-900 font-semibold">Sayfa bulunamadı</h2>
        <Button onClick={() => navigate(-1)} variant="outline" className="border-amber-300 text-amber-900">
          <ChevronLeft className="w-4 h-4 mr-2" /> Geri Dön
        </Button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button
          onClick={() => navigate(-1)}
          variant="ghost"
          className="mb-6 text-amber-700 hover:text-amber-900 hover:bg-amber-100"
          data-testid="dynamic-page-back-btn"
        >
          <ChevronLeft className="w-4 h-4 mr-2" /> Geri
        </Button>

        {page.image_url && (
          <div className="w-full h-64 rounded-2xl overflow-hidden mb-8 shadow-lg">
            <img src={page.image_url} alt={page.title} className="w-full h-full object-cover" />
          </div>
        )}

        <h1
          className="text-4xl sm:text-5xl font-bold text-amber-900 mb-8"
          style={{ fontFamily: 'Merriweather, serif' }}
          data-testid="dynamic-page-title"
        >
          {page.title}
        </h1>

        <div
          className="text-amber-800 leading-relaxed text-lg"
          data-testid="dynamic-page-content"
        >
          <HtmlContent html={page.content} className="text-amber-800" />
        </div>
      </div>
    </div>
  );
}
